import React from 'react';

const MapControl = ({ zoomIn, zoomOut }) => {
  return (
    <div className='vesta-control-zoom-buttons-container'>
      <button className='vesta-control-zoom-button vesta-control-zoom-button--react vesta-zoom-in' onClick={zoomIn}>
        <i className='fa-solid fa-plus'></i>
      </button>
      <button className='vesta-control-zoom-button vesta-control-zoom-button--react vesta-zoom-out' onClick={zoomOut}>
        <i className='fa-solid fa-minus'></i>
      </button>
    </div>
  );
};

export default MapControl;
